import React from "react";
import { btnPrimary, btnSecondary } from "./adminProductUi";

const AdminEditModalFooter = ({ onClose, onSave, saveLabel = "Save changes" }) => (
  <>
    <button type="button" onClick={onClose} className={btnSecondary}>
      Cancel
    </button>
    <button type="button" onClick={onSave} className={btnPrimary}>
      {saveLabel}
    </button>
  </>
);

export default AdminEditModalFooter;
